<template>
  <div :class="{
    'container-manage': !isMenuMiniSize,
    'container-manage-thin-menu': isMenuMiniSize
    }"
    class="disp-scroll">
    <OverlayLoading
      :absoluteFlg="false"
      v-if="isSendLoading"/>
    <ModalSelectMedia @updated="selectImage"/>
    <ModalAutoScout
      ref="autoscout"
      :isShowModal="isOpenModalAutoScout"
      :scouts="scouts"
      @setAutoScout="setAutoScout"
      @cancel="changeModalAutoScout"/>
    <ModalHowToScout :isShowModal="isHowToScoutModal" @cancel="cancelHowToScoutModal"/>
    <!-- コピー用 -->
    <input type="hidden" style="opacity: 0 !important;" id="copy-code" :value="singleURL"/>
    <!-- ヘッダー -->
    <div class="header-box">
      <div class="header-menu">
        <p><b style="font-size:28px; font-weight: 800;">Scout</b></p>
        <p style="margin-left: 25px; font-size:16px; color: #666; margin-top: 8px;">ダイレクトスカウト画面</p>
      </div>
      <div class="header-menu">
        <div class="img-wrapper" @click="openHowToScoutModal()">
            <img src="@/assets/template/question_btn.png" alt="">
        </div>
        <button class="button is-small is-primary" style="background: #bb5; margin-right: 8px;" @click="openScoutSetting()"><span class="mdi mdi-table-edit" style="margin-right: 5px;"></span>スカウト設定</button>
      </div>
    </div>
    <!-- スカウト設定 -->
    <div class="setting-scout" @click="isOpenScout = false" v-if="isOpenScout"></div>
    <transition name="right">
      <div class="setting-scout-slide-menu" v-if="isOpenScout">
        <h2 style="margin-bottom: 8px; font-weight: 600;"><span class="mdi mdi-table-settings" style="margin-right: 8px;"></span>スカウト設定</h2>
        <table class="setting-scout-table disp-scroll" v-if="tempScouts.length > 0">
          <tr style="display: table;">
            <th style="width: 10px;"></th>
            <th style="width: 10px;"></th>
            <th style="width: 60px;">スカウト名</th>
            <th style="width: 60px;">カテゴリ</th>
            <th style="width: 60px;">タイプ</th>
          </tr>
          <tr style="display: table;" v-for="(t, i) in tempScouts" :key="i">
            <td style="width: 10px; vertical-align: middle; padding:0px; cursor: pointer;" @click="tempScout=Object.assign({},t);isOpenScoutNew=false;isOpenScoutDelete=true;"><span class="mdi mdi-delete mdi-18px"></span></td>
            <td style="width: 10px; vertical-align: middle; padding:0px; cursor: pointer;" @click="tempScout=Object.assign({},t);isOpenScoutNew=true;isOpenScoutDelete=false;"><span class="mdi mdi-square-edit-outline mdi-18px"></span></td>
            <td style="width: 60px; vertical-align: middle;">{{t.name}}</td>
            <td style="width: 60px; text-align: center; vertical-align: middle;">{{scoutCategories[t.category]}}</td>
            <td style="width: 60px; text-align: center; vertical-align: middle;">{{t.category != 0 ? scoutTypes[t.type] : '-'}}</td>
          </tr>
        </table>
        <button class="make-button button is-small is-primary is-fullwidth -top-8px" @click="openNewScout()">新規作成</button>
        <!-- 削除 -->
        <div style="position: absolute; bottom: 0; right: 0; height: 75%; width: 400px; background: #f0f0f0; padding: 16px; z-index: 3; overflow-y: scroll;" v-if="isOpenScoutDelete">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
            <template>
              <p style="text-align: left; font-weight: 600;"><span class="mdi mdi-delete -right-8px"></span>削除</p>
            </template>
            <button @click="isOpenScoutDelete=false" class="button is-small" style="background: transparent; border: none;"><span class="mdi mdi-close"></span></button>
          </div>
          <div style="display: flex; align-items: center; margin:24px 0px 16px 0px;">
            <p style="text-align: left; font-size: smaller;"><b>"{{tempScout.name}}"</b> を削除してもよろしいですか。</p>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px;">
            <button class="button is-small" style="margin-right:8px;" @click="deleteScout()">はい</button>
            <button class="button is-small" @click="isOpenScoutDelete=false">いいえ</button>
          </div>
        </div>
        <!-- モーダルスカウト -->
        <div class="modal-scout" v-if="isOpenScoutNew">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
            <template v-if="!tempScout.company">
              <p style="text-align: left; font-weight: 600;"><span class="mdi mdi-note-plus-outline -right-8px"></span>新規作成</p>
            </template>
            <template v-else>
              <p style="text-align: left; font-weight: 600;"><span class="mdi mdi-square-edit-outline -right-8px"></span>変更</p>
            </template>
            <button @click="isOpenScoutNew=false" class="button is-small" style="background: transparent; border: none;"><span class="mdi mdi-close"></span></button>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px;">
            <p style="text-align: left; font-size: smaller; width: 100px;">タイトル</p>
            <input class="input is-small" placeholder="タイトル" v-model="tempScout.name" style="margin-left: 10px; width: calc(100% - 100px);"/>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px;">
            <p style="text-align: left; font-size: smaller; width: 100px;">カテゴリ</p>
            <select class="select is-small" style="margin-left: 10px; width: calc(100% - 100px);" v-model="tempScout.category">
              <option :value="idx" v-for="(s, idx) in scoutCategories" :key="idx">
                {{s}}
              </option>
            </select>
          </div>
          <!-- 巨大化以外 -->
          <template v-if="tempScout.category > 0">
            <div style="display: flex; align-items: center; margin-bottom: 8px;">
              <p style="text-align: left; font-size: smaller; width: 100px;">タイプ</p>
              <select class="select is-small" style="margin-left: 10px; width: calc(100% - 100px);" v-model="tempScout.type">
                <option :value="idx" v-for="(s, idx) in scoutTypes" :key="idx">
                  {{s}}
                </option>
              </select>
            </div>
          </template>
          <!-- スカウトメッセージ -->
          <template v-if="tempScout.category == 1">
            <div style="display: flex; align-items: center; margin-bottom: 8px;">
              <p style="text-align: left; font-size: smaller; width: 100px;">画像</p>
              <button class="button is-small" style="margin-left: 10px; width: calc(100% - 100px);" @click="openSelectModal">メディア倉庫から選択</button>
            </div>
            <img style="width: 100%; height: 100px; object-fit: cover;" :src="getImage(tempScout.scout_image_ref, tempScout.store_image)"/>
            <div style="display: flex; margin-bottom: 8px;">
              <p style="text-align: left; font-size: smaller; width: 100px;">内容</p>
              <textarea class="input is-small" placeholder="内容" v-model="tempScout.content" style="margin-left: 10px; width: calc(100% - 100px); height: 128px;"/>
            </div>
          </template>
          <!-- 求人ノベル -->
          <template v-if="tempScout.category == 2">
            <div style="display: flex; align-items: center; margin-bottom: 8px;">
              <p style="text-align: left; font-size: smaller; width: 100px;">求人ノベル</p>
              <select class="select is-small" style="margin-left: 10px; width: calc(100% - 100px);" v-model="tempScout.story">
                <option :value="s.story_id" v-for="(s, idx) in stories" :key="idx">
                  {{s.title}}
                </option>
              </select>
            </div>
          </template>
          <!-- ロボ -->
          <template v-if="tempScout.category == 3">
            <div style="display: flex; align-items: center; margin-bottom: 8px;">
              <p style="text-align: left; font-size: smaller; width: 100px;">ロボ</p>
              <select class="select is-small" style="margin-left: 10px; width: calc(100% - 100px);" v-model="tempScout.chatbot">
                <option :value="c.bot_id" v-for="(c, idx) in chatbots" :key="idx">
                  {{c.name}}
                </option>
              </select>
            </div>
          </template>
          <template v-if="tempScout.category == 2 || tempScout.category == 3">
            <div style="display: flex; margin-bottom: 8px;">
              <p style="text-align: left; font-size: smaller; width: 100px;">表示タイトル</p>
              <input type="text" class="input is-small" style="margin-left: 10px; width: calc(100% - 100px);"
              placeholder="求人ノベル/ロボのご紹介"  v-model="showTitle"/>
            </div>
            <div style="display: flex; margin-bottom: 8px;">
              <p style="text-align: left; font-size: smaller; width: 100px;">内容</p>
              <input type="text" class="input is-small" style="margin-left: 10px; width: calc(100% - 100px);"
              placeholder="[企業名]についてより知りたい方はこちら" v-model="showContent"/>
            </div>
            <div style="text-align: left; margin-bottom: 16px;">
              <p style="font-size: 10px; color: gray;">表示タイトルと内容が枠に納まらない長さのとき文章の後半が省略されます。</p>
            </div>
          </template>
          <template v-if="tempScout.category >= 1">
            <div style="display: flex; align-items: center; margin-bottom: 8px;">
              <p style="text-align: left; font-size: smaller; width: 130px;">大きさ</p>
              <b-field style="flex-wrap: wrap; width: 100%;">
                <input class="slider" style="margin-left: 10px;" type="range" max="2" min="1" step="0.5" v-model="tempScout.disp_size"/>
                <div style="margin-left: 10px; display: flex; justify-content: space-between; font-size: smaller; width: 100%;">
                  <p>小</p>
                  <p>中</p>
                  <p>大</p>
                </div>
              </b-field>
            </div>
          </template>
          <template v-if="tempScout.category === 1">
            <div style="display: flex; align-items: center; margin-bottom: 8px;">
              <p style="text-align: left; font-size: smaller; width: 100px;">返信形式</p>
              <b-radio v-model="tempScout.reply_type"
                name="name"
                size="is-small"
                native-value="0">
                メールアドレス入力
              </b-radio>
              <b-radio v-model="tempScout.reply_type"
                name="name"
                size="is-small"
                style="margin-left: 8px;"
                native-value="1">
                ユーザー情報入力
              </b-radio>
            </div>
          </template>
          <button class="button is-small is-fullwidth" @click="createScout()"
            :disabled="(tempScout.category == 1 && !tempScout.content) || (tempScout.category == 2 && !tempScout.story) || (tempScout.category==3 && !tempScout.chatbot)"
            v-if="!tempScout.company"><span class="mdi mdi-plus" style="margin-right: 8px;"></span>追加</button>
          <button class="button is-small is-fullwidth" @click="updateScout()"
            :disabled="(tempScout.category == 1 && !tempScout.content) || (tempScout.category == 2 && !tempScout.story) || (tempScout.category==3 && !tempScout.chatbot)"
            v-else><span class="mdi mdi-plus" style="margin-right: 8px;"></span>更新</button>
        </div>
      </div>
    </transition>
    <!-- メッセージアクション -->
    <div class="drawer-back" @click="isOpenMessageMenu = false" v-if="isOpenMessageMenu"></div>
    <transition name="right">
      <div class="drawer-menu" v-if="isOpenMessageMenu">
        <h2 style="margin-bottom: 8px; font-weight: 600;"><span class="mdi mdi-message" style="margin-right: 8px;"></span>メッセージ</h2>
        <!-- 切替 -->
        <div style="display: flex; flex-wrap: wrap; align-items: center; margin-bottom: 8px; font-weight: 600; height: 100%; width: 100%;">
          <div class="scroll-box disp-scroll" @scroll="loadMessage" :class="{'talk-box': user.permission !== 2, 'watch-box': user.permission === 2}" v-if="chatLogs.length!==0">
            <div class="mdi mdi-loading mdi-spin mdi-48px" v-if="chatLogsLoading"></div>
              <draggable v-model="action" :options="{animation: 250, group: 'CHAT', handle: '.item-handle'}">
                <div>
                  <Balloon
                    v-for="(chat, index) in chatLogs" :key="index"
                    :id="'scrollto-' + index"
                    :speaker="chat.speaker"
                    :name="chat.name"
                    :icon="chat.icon"
                    :message="chat.message"
                    :time="displayDate(chat)"
                    :readTime="new Date()"
                    :isBot="chat.isBot"
                    :email="chat.email"
                    :isManager="chat.isManager"
                    :files="chat.files"
                    :filename="chat.filename"
                    :status="chat.status"
                    :parameter="chat.parameter">
                  </Balloon>
                </div>
              </draggable>
            <div style="height: 10vh; width: 10vw;"></div>
            <div class="loading is-typing"><span v-for="(m, i) in getTyping()" :key="i">{{ m }}</span></div>
          </div>
          <InputForm></InputForm>
        </div>
      </div>
    </transition>
    <!-- スカウト返信履歴 -->
    <div class="drawer-back" @click="isOpenScoutReplyMenu = false" v-if="isOpenScoutReplyMenu"></div>
    <transition name="right">
      <div class="drawer-menu" v-if="isOpenScoutReplyMenu">
        <h2 style="margin-bottom: 8px; font-weight: 600;"><span class="mdi mdi-message" style="margin-right: 8px;"></span>スカウト返信履歴</h2>
        <section class="seeker-reply-container disp-scroll">
          <template v-if="scoutReplyLoading === true">
            <div>
              <p><span class="mdi mdi-loading mdi-spin" style="font-size: 40px;"></span></p>
            </div>
          </template>
          <template v-else-if="scoutReplyLoading === false">
            <template v-if="seekerReplyList.length > 0">
              <div v-for="(seekerReply, i) in seekerReplyList" :key="i" style="margin-bottom: 16px;">
                <div class="seeker-reply-content">
                  <p style="white-space: pre-wrap;">{{seekerReply.reply}}</p>
                </div>
                <div class="seeker-reply-date">
                  {{new Date(seekerReply.created_at).toLocaleString('ja-JP')}}
                </div>
              </div>
            </template>
            <template v-if="seekerReplyList.length === 0">
              <div>
                <p style="font-size: 12px; text-align: left;">この訪問者からは返信が来ておりません。</p>
              </div>
            </template>
          </template>
        </section>
      </div>
    </transition>
    <!-- お問い合わせ履歴 -->
    <div class="drawer-back" @click="isOpenContactMenu = false" v-if="isOpenContactMenu"></div>
    <transition name="right">
      <div class="drawer-menu" v-if="isOpenContactMenu">
        <h2 style="margin-bottom: 8px; font-weight: 600;"><span class="mdi mdi-message" style="margin-right: 8px;"></span>お問い合わせ履歴</h2>
        <section class="seeker-reply-container disp-scroll">
          <template v-if="cbContactLoading === true">
            <div>
              <p><span class="mdi mdi-loading mdi-spin" style="font-size: 40px;"></span></p>
            </div>
          </template>
          <template v-else-if="scoutReplyLoading === false">
            <template v-if="seekerContactList.length > 0">
              <div v-for="(seekerContact, i) in seekerContactList" :key="i" style="margin-bottom: 16px;">
                <div class="seeker-reply-content">
                  <p style="white-space: pre-wrap;">{{seekerContact.content}}</p>
                </div>
                <div class="seeker-reply-date">
                  {{new Date(seekerContact.created_at).toLocaleString('ja-JP')}}
                </div>
              </div>
            </template>
            <template v-if="seekerContactList.length === 0">
              <div>
                <p style="font-size: 12px; text-align: left;">この訪問者からはお問い合わせが来ておりません。</p>
              </div>
            </template>
          </template>
        </section>
      </div>
    </transition>
    <!-- スカウトグラフ -->
    <b-collapse class="card graph-card" animation="slide" aria-id="contentIdForA11y3" v-if="scoutGraphData">
      <div
        slot="trigger"
        slot-scope="props"
        class="card-header"
        role="button"
        aria-controls="contentIdForA11y3">
        <p class="card-header-title">
          スカウトデータ・アクション
        </p>
        <a class="card-header-icon" @click="isDataOpen=!isDataOpen">
            <b-icon
                :icon="props.open ? 'menu-down' : 'menu-up'">
            </b-icon>
        </a>
      </div>
      <ScoutGraphView
        :scouts="scouts"
        :scoutGraphData="scoutGraphData"
        :scoutAutoSending="scoutAutoSending"
        @setAllScout="setAllScout"
        @changeModalAutoScout="changeModalAutoScout"
        aria-controls="contentIdForA11y3"/>
    </b-collapse>
    <div v-else>
      <span class="mdi mdi-loading mdi-spin"></span>
    </div>
    <!-- スカウト画面 -->
    <ScoutTableView
    ref="sctable"
    :isDataOpen="isDataOpen"
    @sendMessage="sendMessage"
    @sendEmail="sendEmail"
    @scoutReplyHistory="scoutReplyHistory"
    @contactHistory="contactHistory"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import draggable from 'vuedraggable'
import moment from 'moment'
import ModalAutoScout from '@/views/DashBoard/DirectTalk/ModalAutoScout'
import ScoutTableView from '@/views/DashBoard/DirectTalk/ScoutTableView'
import ScoutGraphView from '@/views/DashBoard/DirectTalk/ScoutGraphView'
import Balloon from '@/components/ui/Balloon'
import InputForm from '@/views/DashBoard/DirectTalk/InputForm'
import ModalSelectMedia from '@/components/ui/ModalSelectMedia'
import OverlayLoading from '@/components/animations/OverlayLoading'
import ModalHowToScout from '@/components/organisms/modals/ModalHowToScout'
export default {
  name: 'ScoutView',
  componentName: 'ScoutView',
  components: {
    draggable,
    Balloon,
    InputForm,
    draggable,
    ModalAutoScout,
    ScoutTableView,
    ScoutGraphView,
    ModalSelectMedia,
    OverlayLoading,
    ModalHowToScout
  },
  data () {
    return {
      isOpenModalAutoScout: false,
      isSendLoading: false,
      isChangingImage: false,
      isOpenCloudSync: false,
      isOpenScout: false,
      isOpenScoutDelete: false,
      isOpenScoutNew: false,
      isOpenTemplateMenu: false,
      isOpenMessageMenu: false,
      isOpenScoutReplyMenu: false,
      isOpenContactMenu: false,
      isOpenEmailMenu: false,
      sendEmailTemplate: null,
      sendSMSTemplate: null,
      fromEmail: null,
      toEmail: null,
      ccEmail: null,
      content: null,
      modifyTemplateIndex: 0,
      templateIndex: 0,
      addTemplates: null,
      options: {
        theme: 'snow',
        placeholder: '内容を入力...',
      },
      uri: location.href,
      isTyping: '',
      action: [],
      isNoScroll: false,
      singleURL: '',
      tempChatBot: null,
      tempColumns: null,
      tempScouts: [],
      scoutTypes: [
        'バナー',
        'インタースティシャル',
        'フッター',
      ],
      scoutCategories: [
        'アイコン巨大化',
        'スカウトメッセージ',
        '求人ノベル紹介',
        'ロボ紹介'
      ],
      tempScout: {
        name            : null,
        type            : 0,
        category        : 0,
        scout_image_ref : null,
        catch_copy      : null,
        url             : null,
        content         : null,
        company         : null,
        story           : null,
        chatbot         : null,
        disp_size       : 1.5,
        reply_type      : 0
      },
      scoutsGraphData   : null,
      scoutReplyLoading: false,
      contactLoading: false,
      scoutGraphData: null,
      isHowToScoutModal: false,
      showTitle: '',// 求人ノベル/ロボ紹介の場合の表示タイトル
      showContent: '',// 求人ノベル/ロボ紹介の場合の表示紹介文
      isDataOpen: true,
    }
  },
  created () {
    this.$store.dispatch('auth/getScoutAutoSending', null)
    this.$store.dispatch('directtalk/getScoutGraph')
      .then((d) => {
        this.scoutGraphData = d
      })
  },
  mounted () {
    const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
    this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
    const con = {'is_connect': true}
    this.$store.dispatch('auth/setUserConnect', con)
  },
  computed: {
    ...mapState('auth', ['user', 'emailTemplates', 'scouts', 'scoutAutoSending']),
    ...mapState('chatbot', ['chatbots', 'stories']),
    ...mapState('directtalk', ['seekers', 'isMakingCSV', 'chatData', 'roomlist', 'chatLogs', 'typing', 'selectroom', 'seeker', 'chatLogsLoading', 'messagePages', 'isVideo', 'scrolltalk', 'getSeekerType', 'isConnectRoom', 'isGetMessageMax', 'seekerReplyList', 'seekerContactList', 'cbContactLoading']),
    ...mapState('mediapool', ['images']),
    ...mapState("setting",["isMenuMiniSize"]),
  },
  watch : {
    isConnectRoom: function () {
      if (!this.isConnectRoom) {
        var uri = process.env.WS_ENDPOINT + this.user.companyID + '/' + this.selectroom.name + '/'
        this.$store.dispatch('directtalk/connect', {uri: uri, category: 'managementtool'})
      }
    },
    chatLogs: function () {
      if (this.chatLogs.length !== 0) {
        this.$nextTick()
        setTimeout(() => {this.scrollDown()}, 0)
        this.$store.dispatch('directtalk/setIsRead', 'mgtool')
      }
    },
    seekerReplyList () {
      this.scoutReplyLoading = false
    },
    'tempScout.content' () {
      if (!this.tempScout.content) {
        this.showTitle = ''
        this.showContent = ''
        return
      }
      let c = this.tempScout.content.split('¥n')
      if (c.length == 2) {
        if (this.showTitle != c[0]) {
          this.showTitle = c[0]
        }
        if (this.showContent != c[1]) {
          this.showContent = c[1]
        }
      } else {
        this.showTitle = ''
        this.showContent = ''
      }
    },
    showTitle () {
      if (this.tempScout.category == 2 || this.tempScout.category == 3) this.tempScout.content = this.showTitle + '¥n' + this.showContent
    },
    showContent () {
      if (this.tempScout.category == 2 || this.tempScout.category == 3) this.tempScout.content = this.showTitle + '¥n' + this.showContent
    }
  },
  methods: {
    getImage (id, img) {
      if (this.isChangingImage) {
        if (id) {
          for (let i of this.images) {
            if (i.pk == id) return i.image_data
          }
        }
        return require('@/assets/scene/40.jpg')
      } else {
        if (img) return img
        else return require('@/assets/scene/40.jpg')
      }
    },
    openSelectModal () {
      this.$store.dispatch('mediapool/openSelectModal', {type:'image'})
    },
    selectImage (id) {
      this.isChangingImage = true
      for (let i of this.images) {
        if (i.image_id == id) {
          this.tempScout.scout_image_ref = i.pk
          break
        }
      }
    },
    openNewScout () {
      this.tempScout = {
        name            : null,
        type            : 0,
        category        : 0,
        scout_image_ref : null,
        catch_copy      : null,
        url             : null,
        content         : null,
        company         : null,
        story           : null,
        chatbot         : null,
        disp_size       : 1.5,
        reply_type    : 0
      }
      this.isOpenScoutNew = true
      this.isChangingImage = false
    },
    createScout () {
      let createTempScout = this.tempScout
      createTempScout.company = this.user.companyPK
      this.$store.dispatch('auth/createScout', createTempScout)
      this.tempScout = {
        name            : null,
        type            : 0,
        category        : 0,
        scout_image_ref : null,
        catch_copy      : null,
        url             : null,
        content         : null,
        company         : null,
        story           : null,
        chatbot         : null,
        disp_size       : 1.5,
        reply_type      : 0
      }
      this.isOpenScoutNew = false
    },
    updateScout () {
      let updateTempScout = this.tempScout
      this.$store.dispatch('auth/updateScout', updateTempScout)
      this.tempScout = {
        name            : null,
        type            : 0,
        category        : 0,
        scout_image_ref : null,
        catch_copy      : null,
        url             : null,
        content         : null,
        company         : null,
        story           : null,
        chatbot         : null,
        disp_size       : 1.5,
        reply_type      : 0
      }
      this.isOpenScoutNew = false
    },
    deleteScout () {
      let deleteTempScout = this.tempScout.pk
      this.$store.dispatch('auth/deleteScout', deleteTempScout)
      this.tempScout = {
        name            : null,
        type            : 0,
        category        : 0,
        scout_image_ref : null,
        catch_copy      : null,
        url             : null,
        content         : null,
        company         : null,
        story           : null,
        chatbot         : null,
        disp_size       : 1.5,
        reply_type      : 0
      }
      this.isOpenScoutDelete = false
    },
    createCompanyEmailTemplate (data) {
      let createTemplate = {
        name       : 'no title',
        from_email : '',
        to_email   : '',
        cc_email   : '',
        template   : '',
        company    : this.user.companyPK
      }
      this.$store.dispatch('auth/createCompanyEmailTemplate', createTemplate)
      alert('新規作成をしました。メールテンプレートメニューからお選びください。')
    },
    updateCompanyEmailTemplate (data) {
      let updateTemplate = data
      this.$store.dispatch('auth/updateCompanyEmailTemplate', updateTemplate)
      alert('保存しました。')
    },
    deleteCompanyEmailTemplate (id) {
      this.$store.dispatch('auth/deleteCompanyEmailTemplate', id)
      alert('削除しました。')
    },
    changeEmailTemplate () {
      let tempToEmail = this.sendEmailTemplate.to_email
      this.sendEmailTemplate = this.emailTemplates[this.templateIndex]
      this.sendEmailTemplate.to_email = tempToEmail
      alert('テンプレートを変更いたしました。')
    },
    copyLink () {
      if (!this.tempChatBot) {
        alert('ロボを選択してください。')
        return
      }
      this.singleURL = process.env.OWN_ENDPOINT + '/single/' + this.user.companyID + '/' + this.tempChatBot.bot_id
      this.$nextTick(() => {
        let codeToCopy = document.querySelector('#copy-code')
        codeToCopy.setAttribute('type', 'text')
        codeToCopy.select()
        document.execCommand('copy')
        this.$buefy.snackbar.open({
          message: 'ロボ表示URLをコピーしました！',
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true
        })
        codeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      })
    },
    openCloudSync () {
      this.isOpenCloudSync = true
    },
    openScoutSetting () {
      this.tempScouts = this.scouts
      this.isOpenScout = true
      this.isChangingImage = false
    },
    openEmailTemplate () {
      this.isOpenTemplateMenu = true
      if (this.emailTemplates.length == 0) {
        let createTemplate = {
          name       : 'no title',
          from_email : '',
          to_email   : '',
          cc_email   : '',
          template   : '',
          company    : this.user.companyPK
        }
        this.$store.dispatch('auth/createCompanyEmailTemplate', createTemplate)
      }
    },
    sendEmail (sk) {
      this.sendEmailTemplate = this.emailTemplates[0]
      this.sendEmailTemplate.to_email = sk.email
      this.isOpenEmailMenu = true
    },
    sendMessage (sk) {
      this.selectRoom(sk)
      this.isOpenMessageMenu = true
    },
    scoutReplyHistory (sk) {
      this.scoutReplyLoading = true
      this.$store.dispatch('directtalk/fetchSeekerReply', {seeker: sk.id})
      this.isOpenScoutReplyMenu = true
    },
    contactHistory (sk) {
      this.contactLoading = true
      this.$store.dispatch('directtalk/fetchSeekerContact', {seeker: sk.id})
      this.isOpenContactMenu = true
    },
    selectRoom (sk) {
      console.debug('*** Start *** selectRoom')
      if (this.isConnectRoom) {
        console.debug('isConnectRoom is true')
        this.$store.dispatch('directtalk/disconnect')
      }
      var uri = process.env.WS_ENDPOINT + this.user.companyID + '/' + sk.sessionid + '/'
      this.$store.dispatch('directtalk/selectRoom', {name: sk.sessionid, skname: sk.name, group: sk.group})
      console.log('DashBoard InputForm WS:' + uri)
      this.$store.dispatch('directtalk/connect', {uri: uri, category: 'managementtool'})
        .then(() => this.$store.dispatch('directtalk/getMessage', {name: 'manager', pages: this.messagePages}))
      var vm = this
      setTimeout(function () {
        var rand = Math.floor(Math.random() * 9)
        vm.chatData.icon = process.env.API_ENDPOINT + '/img_s/icon/' + rand + '.png'
        console.log('icon_uri: ' + vm.chatData.icon)
        var uriSpeaker = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : process.env.WDT_ENDPOINT
        uriSpeaker += '/dashboard/manage'
        vm.$store.dispatch('directtalk/setManager', uriSpeaker)
      }, 300)
    },
    loadMessage () {
      var target = document.querySelector('div.scroll-box')
      if (target.scrollTop === 0 && !this.isGetMessageMax) {
        this.isNoScroll = true
        this.$store.dispatch('directtalk/getMessage', {name: 'manager', pages: Number(this.messagePages + 1)})
      }
    },
    getTyping () {
      var idx = -1
      var vm = this
      this.roomlist.active.find(function (item, i) {
        if (item.name === vm.selectroom.name) {
          idx = i
          return i
        }
      })
      if (idx > -1) {
        if (this.roomlist.active[idx].talk === 1) {
          return '入力中です...'
        } else if (this.roomlist.active[idx].talk === 0) {
          return ''
        }
      } else {
        return ''
      }
    },
    scrollDown () {
      console.debug('*** Start *** scrollDown')
      if (this.isNoScroll) {
        console.info('isNoScroll is true')
        this.isNoScroll = false
        var scrollLine = document.getElementById('scrollto-' + 20)
        console.log('scrollLine',scrollLine)
        if (!scrollLine) return
        scrollLine.scrollIntoView(true)
      } else if (this.chatLogs.length !== 0) {
        console.info('this.chatLogs.length !== 0')
        var target = document.querySelector('div.scroll-box')
        if (!target) return
        target.scrollTop = target.scrollHeight
      }
      console.debug('*** End *** scrollDown')
    },
    setAllScout (data) {
      this.isSendLoading = true
      this.$store.dispatch('directtalk/setAllScout', data)
        .then(() => {
          this.isSendLoading = false
          this.$refs.sctable.deleteFilterAll()
          this.$store.dispatch('directtalk/getScoutGraph')
            .then((d) => {
              this.scoutGraphData = d
            })
        })
    },
    changeModalAutoScout (flg) {
      this.isOpenModalAutoScout = flg
      if (flg && this.scoutAutoSending.length > 0) {
        this.$refs.autoscout.autoScoutSettingSync = this.$_.cloneDeep(this.scoutAutoSending[0].parameter)
        this.$refs.autoscout.autoScoutSettingSync.scout = Object.values(this.$_.pickBy(this.scouts, (item) => {
          return item.pk === this.$refs.autoscout.autoScoutSettingSync.scout.pk
        }))[0]
      }
    },
    setAutoScout (data) {
      let temp = {
        parameter: data,
        company: this.user.companyPK
      }
      if (this.scoutAutoSending.length === 0) {
        // 初期作成
        this.$store.dispatch('auth/createScoutAutoSending', temp)
      } else {
        // 次回以降
        temp.pk = this.scoutAutoSending[0].pk
        this.$store.dispatch('auth/updateScoutAutoSending', temp)
      }
      this.isOpenModalAutoScout = false
    },
    openHowToScoutModal () {
      this.isHowToScoutModal = true
    },
    cancelHowToScoutModal () {
      this.isHowToScoutModal = false
    },
    displayDate(chat) {
      if (!isNaN(chat.createdAt)) {
        return new Date(chat.createdAt)
      } else {
        return new Date(chat.createdAtOther)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  border-collapse:collapse;
  margin: 0 auto;
  display: block;
  height: calc(100% - 180px);
  table-layout: fixed;
}
tr {
  width: 100%;
}
td,th {
  padding: 8px;
  margin: auto;
  font-size: smaller;
  border-style: solid;
  border-width: 1px;
  border-color: #AA0066;
}
td {
  text-align: left;
  padding: 8px;
}
th {
  color:#fff;
  background:#AA0066;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10000;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}
.drag-button {
  width: 100%;
  height: 35px;
  background: transparent;
  border: none;
}
.container-manage {
  height: 100vh;
  width: calc(100% - 205px);
}
.container-manage-thin-menu {
  height: 100vh;
  width: calc(100% - 55px);
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 10px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
  flex-wrap: wrap;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
.scroll-box {
  height: calc(100% - 110px);
  width: 100%;
}
.slider {
  width: 100%;
  margin-top: 5px;
  background: rgba(200, 200, 200, 0.6) !important;
}
.drawer-menu {
  position: fixed;
  top: 80px;
  right: 0;
  height: calc(100% - 80px);
  width: 40%;
  min-width: 400px;
  background: #FEFEFE;
  padding: 16px;
  z-index: 3;
}
.seeker-reply-container {
  height: 95%;
}
.seeker-reply-content {
  text-align: left;
  background: #ffffff;
  border: solid 1px #dbdbdb;
  font-size: 12px;
  padding: 8px;
  overflow: auto;
  height: 120px;
}
.seeker-reply-content::-webkit-scrollbar {
  width:  5px;
  height: 5px;
  visibility: hidden;
}
.seeker-reply-date {
  text-align: right;
  font-size: 10px;
  margin-top: 8px
}
.drawer-back {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 3;
  top: 80px;
}
.graph-card {
  margin: 40px;
  border-radius: 16px;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.2);
}
.setting-scout {
  height: 100%;
  width: 100%;
  background:rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 3; top: 0;
  &-slide-menu {
    position: fixed;
    top: 0px;
    right: 0;
    height: 100%;
    width: 400px;
    background: #FEFEFE;
    padding: 16px;
    z-index: 4; 
  }
}
.setting-scout-table {
  height: calc(100% - 80px);
}
.make-button {
  margin-top:24px;
}
.modal-scout {
  position: fixed;
  bottom: 0;
  right: 0;
  height: 75%;
  width: 400px;
  background: #f0f0f0;
  padding: 16px;
  z-index: 3;
  overflow-y: scroll;
}
.img-wrapper {
  width: 32px;
  margin-right: 16px;
  img {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/DirectTalk/ScoutView.vue